import { Platform } from 'react-native'
import { Redirect, useRouter } from 'expo-router'
// import { AuthNavigator } from '@/navigation/auth-navigator'
import { SignUp } from '@/screens/index'
import { useStore } from '@/models'
import { useSessionStore } from '@/models/session/useSessionStore'

export default function Login() {
  const router = useRouter()
  const store = useStore()

  const isLoggedIn = useSessionStore((state) => state.tokenConfig?.accessToken !== undefined)

  if (isLoggedIn) {
    return <Redirect href="/" />
  }

  if (Platform.OS !== 'web') {
    return <SignUp />
  }

  return <SignUp />
}
